export const REPORT_ID = 'slide-12';
export const SLIDE_NUMBER = 12;

// slides-units dictionary ids
export const UNIT_USD_MT = 11;
export const UNIT_USD_BU = 12;
export const UNIT_CENTS_LB = 15;

// @units values for each UOM option. Both keep all units (export needs every UOM), only the order differs:
// the first unit available for a commodity is shown, and the first unit in @units is the selected UOM.
// USD/BU is only available for Wheat, Corn Grain, Soybeans, Sunflower and Rapeseed, others keep USD/MT or CENTS/LB.
export const UOM_UNITS: Record<number, number[]> = {
  [UNIT_USD_MT]: [UNIT_USD_MT, UNIT_USD_BU, UNIT_CENTS_LB],
  [UNIT_USD_BU]: [UNIT_USD_BU, UNIT_USD_MT, UNIT_CENTS_LB],
};
